import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={22}
    height={22}
    fill="none"
    {...props}
    style={{
        animation: 'rotation 2s infinite linear',
      }}
  >
    <style>{`
        @keyframes rotation {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(-359deg);
          }
        }
        `}</style>
    <path
      fill="url(#loader_gradient_a)"
      d="M20.165 10.84a9.166 9.166 0 1 1-7.057-8.762L12.75 3.59a7.614 7.614 0 1 0 5.862 7.277l1.552-.027Z"
    />
    <defs>
      <linearGradient
        id="loader_gradient_a"
        x1={20.005}
        x2={20.325}
        y1={1.674}
        y2={20.005}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF1866" />
        <stop offset={0.27} stopColor="#FD0167" />
        <stop offset={0.496} stopColor="#F00188" />
        <stop offset={0.649} stopColor="#DD01A0" />
        <stop offset={0.755} stopColor="#D203B4" />
        <stop offset={1} stopColor="#C811CB" />
      </linearGradient>
    </defs>
  </svg>
)
export default SvgComponent
